// This takes a curricula tree with an assumed structure and parses out
// a tree that's easier to work with for fixing title indexes
import { INode } from 'shared/types/tree'
import { ContentItem } from './types'
import { nodesOfTypeWithContent } from '../../utility/TreeHelpers'
import { NodeType } from 'shared/types/ingestion'
import { nodeTitleTest } from './utility'

export function getUnitLists(tree: INode) {
  const unitNodeLists = nodesOfTypeWithContent({
    tree,
    types: [NodeType.NodeList],
    extraCheck: (node: INode) => node.body?.type === NodeType.Unit,
  })
  return unitNodeLists.map(getUnitListChildren)
}

function getUnitListChildren(unitNodeList: INode) {
  return unitNodeList.nodes.reduce<ContentItem[]>((acc, unit) => {
    if (unit.type === NodeType.Unit) {
      acc.push({
        node: {
          ...unit,
          nodes: [],
        },
        children: getUnitChildren(unit),
      })
    }
    return acc
  }, [])
}

// Under units are lessons
function getUnitChildren(tree: INode) {
  const nodes = nodesOfTypeWithContent({
    tree,
    types: [NodeType.NodeList],
    extraCheck: (node: INode) =>
      node.body?.type === NodeType.LessonPlan &&
      ['Lessons'].includes(node.title),
  })
  return nodes.reduce<ContentItem[]>((acc, lessonNodeList) => {
    lessonNodeList.nodes.forEach((lesson) => {
      if (lesson.type === NodeType.LessonPlan) {
        acc.push({
          node: {
            ...lesson,
            nodes: [],
          },
          children: getLessonChildren(lesson),
        })
      }
    })
    return acc
  }, [])
}

function getLessonChildren(tree: INode) {
  const testNodeList = (node: INode) => {
    switch (node.body?.type) {
      case NodeType.Activity: {
        return node.title === 'Activities'
      }
      case NodeType.Assessment: {
        return node.title === 'Practice Problems'
      }
      case NodeType.Presentation: {
        return node.title === 'Presentations'
      }
    }
    return false
  }
  const nodes = nodesOfTypeWithContent({
    tree,
    types: [NodeType.NodeList],
    extraCheck: testNodeList,
  })

  return nodes.reduce<ContentItem[]>((acc, nodeList) => {
    nodeList.nodes.forEach((node) => {
      if (nodeTitleTest(node)) {
        acc.push({
          node: {
            ...node,
            nodes: [],
          },
          children: [],
        })
      }
    })
    return acc
  }, [])
}
